<ng-container [ngSwitch]="file?.fileType" *ngIf="!this.hasNLPHighLights; else nlpHighlights">
  <div class="file-viewer-wrapper" *ngSwitchCase="'pdf'">
    <ng2-pdfjs-viewer  [openFile]="false"
                       [viewBookmark]="false"
                       pagemode="none"
                       #inlinePdfViewer></ng2-pdfjs-viewer>
    <gen-overlay-loader class="loader" *ngIf="loading" [showOverlay]="false"></gen-overlay-loader>
  </div>
  <div class="file-viewer-wrapper" *ngSwitchCase="'image'">
    <img src="{{imageBlobUrl}}"
         alt="{{file.name}}"
         *ngIf="!loading;">
    <gen-overlay-loader class="loader" *ngIf="loading" [showOverlay]="false"></gen-overlay-loader>
  </div>
  <div class="file-viewer-wrapper" *ngSwitchCase="'text'">
    <pre id="text-file-viewer" class="text-file-viewer" #inlineTextViewer></pre>
    <gen-overlay-loader class="loader" *ngIf="loading" [showOverlay]="false"></gen-overlay-loader>
  </div>
  <!--added for mp4-->
  <div class="file-viewer-wrapper" *ngSwitchCase="'video'">
    <gen-mp4-viewer [blobUrl]="videoBlobUrl" *ngIf="!loading;"></gen-mp4-viewer>
    <!--<video #media [vgMedia]="media" id="singleVideo" preload="auto" crossorigin>
      <source src="{{videoBlobUrl}}" type="video/mp4">
    </video>-->
    <gen-overlay-loader class="loader" *ngIf="loading" [showOverlay]="false"></gen-overlay-loader>
  </div>
  <div class="event-report-download-link" *ngSwitchDefault>
    <a *ngIf="downloadLink; else downloadBlob" [href]="downloadLink"
       class="textual-content link-content value-item AUTO_VALUE"
       target="_blank">{{file.name}}
    </a>
    <ng-template #downloadBlob>
      <gen-button
        [iconClass]="'icon__DocumentDownload'"
        [text]="'Download File'"
        (click)="emitDownloadFile()">
      </gen-button>
    </ng-template>
  </div>
</ng-container>
<ng-template #nlpHighlights>
  <div class="file-viewer-wrapper">
    <div class="nlp-filter-section-wrapper" *ngIf="nlpConfig?.showFilters">
      <span class="nlp-filter-item" *ngFor="let eType of nlpConfig?.eTypes"><p-checkbox name="eTypes" value="{{eType}}" label="{{eType | titlecase}}" (onChange)="showSelectedHighlights()"[(ngModel)]="selectedETypes" inputId="{{eType}}"></p-checkbox></span>
    </div>
    <pre id="nlp-highlight-file-viewer" [ngClass]="{'nlp-highlight-file-viewer': nlpConfig?.showFilters}" class="text-file-viewer" #inlineTextViewer></pre>
    <gen-overlay-loader class="loader" *ngIf="loading" [showOverlay]="false"></gen-overlay-loader>
  </div>
</ng-template>
